module.exports = __webpack_public_path__ + "static/media/landscap_chatgpt_dec2023.8e62c4da.jpeg";